module.exports = __webpack_public_path__ + "img/step-custom-voice-bg.1235c004.png";